export default __webpack_public_path__ + "static/media/home-preview-saas.947cacd8.jpg";